<template>
  <div class="container1">
    <div id="chart" ref="main" style="width: 100%; height: 200px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      echartArea: null,
    };
  },
  props:{
    souceData:null
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.echartArea = this.$echarts.init(this.$refs.main);
      this.updatedChart();
    },
    updatedChart() {
      var dataArr = [];
      dataArr.push(this.souceData) 
      var rich = {
        white: {
          fontSize: 20,
          color: "#fff",
          fontWeight: "500",
          padding: [20, 0, 0, 0],
        },
        bule: {
          fontSize: 20,
          fontFamily: "DINBold",
          color: "#fff",
          fontWeight: "700",
          padding: [20, 0, 0, 0],
        },
        radius: {
          width: 100,
          fontSize: 20,
          fontWeight: "bold",
          color: "#75B8FF",
          textAlign: "center",
          padding: [20, 0, 0, 0],
        },
        size: {
          height: 400,
          padding: [100, 0, 0, 0],
        },
      };
      const option = {
        // tooltip: {
        //   formatter: "{a} <br/>{b} : {c}%",
        // },
        series: [
          {
            name: "快充端口",
            type: "gauge",
            radius: "80%",
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,
              lineStyle: {
                color: [
                  [
                    dataArr[0].percentage / 100,
                    this.$echarts.graphic.LinearGradient(0, 1, 1, 0, [
                      {
                        offset: 0,
                        color: "rgba(247, 181, 0, 1)",
                      },
                      {
                        offset: 0.55,
                        color: "rgba(247, 181, 0, 1)",
                      },
                    ]),
                  ],
                  [(1, "rgba(255,255,255,.0)")],
                ],
                opacity: 1,
                width: 10,
              },
            },
            splitLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLabel: { show: false },
            pointer: { show: false },
            itemStyle: {
              borderWidth: 30,
              borderColor: "#f0f",
            },
            title: {
              offsetCenter: [0, "-20%"],
              color: "#FFFFFF",
              fontSize: 50,
              fontWeight: 700,
              show: false,
            },
            detail: {
              formatter:  (value)=> {
                var num = Math.round(value);
                return (
                  "{bule|" +
                  num +
                  "}{white|个}" +
                  "{size|" +
                  "}\n{radius|快充端口}"
                );
              },
              rich: rich,
              offsetCenter: ["0%", "0%"],
              show:true,
            },
            data: dataArr,
            zlevel:2,
            z:2
          },
          {
            zlevel:1,
            z:1,
            name: "业务",
            type: "gauge",
            radius: "80%",
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,
              lineStyle: {
                color: [
                  [
                    0,"#081C5C"
                  ],
                  [1,"#081C5C"],
                ],
                opacity: 1,
                width: 10,
              },
            },
            splitLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            splitLabel: { show: false },
            pointer: { show: false },
            itemStyle: {
              borderWidth: 30,
              borderColor: "#f0f",
            },
            title: {
              offsetCenter: [0, "-20%"],
              color: "#FFFFFF",
              fontSize: 50,
              fontWeight: 700,
              show: false,
            }
          },
        ],
      };
      this.echartArea.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.container1 {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/car-system/gauge-chart/gauge-right.vue